import React from "react"
import { Modal, Form, Input, InputNumber, Select, Button } from "antd"
import PropTypes from 'prop-types'

class AddTagModal extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            formData: this.props.formData
        }
    }

    updateFormData(mergeData) {

        const { formData } = this.state

        const newFormData = {
            ...formData,
            ...mergeData
        }

        this.setState({ formData: newFormData })
    }

    onCancel() {
        this.props.onCancel()
    }

    onSubmit() {
        const { formData } = this.state
        this.props.onSubmit(formData)
    }

    render() {

        const { formData } = this.state

        return (
            <Modal
                title="添加场景"
                visible={true}
                maskClosable={false}
                keyboard={false}
                onCancel={() => this.onCancel()}
                width={500}
                okText='保存'
                cancelText='取消'
                onOk={() => this.onSubmit()}
            >
                <div style={{ width: "100%", height: "100%", overflow: "hidden", position: "relative" }}>
                    <Form layout="vertical">
                        <Form.Item label="场景标识">
                            <Input
                                size="small"
                                value={formData.tagId}
                                placeholder="输入场景标识"
                                style={{ width: "100%" }}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => this.updateFormData({ tagId: e.target.value })}
                            />
                        </Form.Item>
                        <Form.Item label="场景名称">
                            <Input
                                size="small"
                                value={formData.name}
                                placeholder="输入场景名称"
                                style={{ width: "100%" }}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => this.updateFormData({ name: e.target.value })}
                            />
                        </Form.Item>
                        <Form.Item label="是否公开">
                            <Select
                                style={{ width: "100%" }}
                                value={formData.isPublic}
                                onChange={(value) => this.updateFormData({ isPublic: value })}
                                size="small"
                                dropdownClassName="ant-jowo-overrides"
                            >
                                <Select.Option value={true}>公开</Select.Option>
                                <Select.Option value={false}>不公开</Select.Option>
                            </Select>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        )
    }
}

AddTagModal.propTypes = {
    formData: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

const defaultFormData = {
    tagId: "",
    name: "",
    isPublic: true
}

AddTagModal.defaultProps = {
    formData: defaultFormData
}

export default AddTagModal